import React from 'react';
import './ui.css';

export const ProgressBar: React.FC<{ value: number; max: number }> = ({ value, max }) => {
  const pct = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  return (
    <div className="ui-progress">
      <div className="ui-progress__fill" style={{ width: `${pct}%` }} />
    </div>
  );
};
